var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-upload",on:{"click":_vm.openUploaderModal}},[(!_vm.inline)?_vm._t("default",function(){return [_vm._v("Upload")]}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }